import React from 'react'

interface TurnoverModalProps {
  isOpen: boolean
  onClose: () => void
  onAcknowledge: () => void
}

const TurnoverModal: React.FC<TurnoverModalProps> = ({ isOpen, onClose, onAcknowledge }) => {
  if (!isOpen) return null

  const mockAlerts = [
    { id: '1', type: 'Missing Rail Car', count: 3, cleared: false },
    { id: '2', type: 'Switch Divergence', count: 1, cleared: false },
    { id: '3', type: 'Crew Report Pending', count: 2, cleared: true },
  ]

  const activeAlerts = mockAlerts.filter(a => !a.cleared)
  const clearedAlerts = mockAlerts.filter(a => a.cleared)

  return (
    <div data-drawer="turnover" className={`modal-overlay ${isOpen ? 'open' : ''}`}>
      <div className="modal">
        <div className="modal-header">
          <h2>Shift Turnover</h2>
          <button className="modal-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="modal-body">
          <div className="alert-summary">
            <h3 style={{ margin: '0 0 12px', fontSize: '14px', color: 'var(--text-primary)' }}>
              Active Alerts ({activeAlerts.length})
            </h3>
            {activeAlerts.map(alert => (
              <div key={alert.id} className="alert-item">
                <span className="alert-type">{alert.type}</span>
                <span className="alert-count">{alert.count} pending</span>
              </div>
            ))}
            {clearedAlerts.length > 0 && (
              <>
                <h3 style={{ margin: '16px 0 12px', fontSize: '14px', color: 'var(--text-primary)' }}>
                  Recently Cleared ({clearedAlerts.length})
                </h3>
                {clearedAlerts.map(alert => (
                  <div key={alert.id} className="alert-item cleared">
                    <span className="alert-type">{alert.type}</span>
                    <span className="alert-count">Cleared</span>
                  </div>
                ))}
              </>
            )}
          </div>
          <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '0' }}>
            Please acknowledge all active alerts before completing the handover.
          </p>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" onClick={onAcknowledge}>
            Acknowledge & Complete
          </button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(TurnoverModal)
